import React, { useRef, useState, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeGetProject } from 'selectors/projects';

import { updateProject } from 'actions/projects';
import { updateProject as updateProjectApi } from 'api/projects-api';

import { useCanUser } from 'shared-hooks/permission';

import Popout from 'components/popout';
import PopoutListActions from 'components/PopoutListActions';
import SelectCustomFieldPopout from 'components/SelectCustomFieldPopout';

import IconMoreHoriz from 'icons/icon-more-horiz';
import IconNumber from 'icons/icon-number';

const DEFAULT_ACTIONS = ['rollup'];

const RoadmapActions = ({ projectId, className = 'roadmap-actions-holder', innerClassName = 'roadmap-actions-trigger', allowedActions, milestonesRollup, projectOwner }) => {
    const { t } = useTranslation('task');
    const [visible, setVisible] = useState(false);
    const [innerVisible, setInnerVisible] = useState(false);
    const popoutCtrl = useRef(null);
    const canEditProject = useCanUser('editProject', projectOwner);

    const actions = useMemo(() => {
        return (allowedActions || DEFAULT_ACTIONS).filter(action => {
            switch (action) {
                case 'rollup':
                    return canEditProject;

                default:
                    return true;

            }
        });
    }, [canEditProject]);

    const hidePopout = useCallback(() => {
        popoutCtrl.current?.hide();
    }, [popoutCtrl]);

    const handleTriggerClick = () => {
        popoutCtrl.current?.show();
    };

    const handleShow = useCallback(() => {
        setVisible(true);
    }, []);

    const handleHide = useCallback(() => {
        setVisible(false);
    }, []);

    const handleCustomFieldSelect = useCallback(fieldId => {
        updateProjectApi(projectId, {
            milestones_rollup: fieldId
        });

        hidePopout();
    }, [projectId, hidePopout]);

    const handleDisableClick = useCallback(() => {
        updateProjectApi(projectId, {
            milestones_rollup: null
        });

        updateProject(projectId, {
            milestones_rollup: null
        }, true);

        hidePopout();
    }, [projectId, hidePopout]);


    const renderAction = useCallback((actionId, onExpand, onCollapse) => {
        switch (actionId) {
            case 'rollup':
                if (milestonesRollup?.fieldId) {
                    return (
                        <div className="item-inner" onClick={handleDisableClick}>
                            <span className="item-icon"><IconNumber /></span>

                            { t('actions.removeRollup.title') }
                        </div>
                    );
                }

                return (
                    <SelectCustomFieldPopout
                        selected={milestonesRollup?.fieldId}
                        projectId={projectId}
                        inline={true}
                        association="task"
                        xAlign="left"
                        defaultXPosition="right"
                        title={ t('actions.setRollup.popoutTitle') }
                        onSelect={handleCustomFieldSelect}
                        onShow={onExpand}
                        onHide={onCollapse}
                    >
                        <div className="item-inner">
                            <span className="item-icon"><IconNumber /></span>

                            { t('actions.setRollup.title') }
                        </div>
                    </SelectCustomFieldPopout>
                );

            default:
                return null;
        }
    }, [t, milestonesRollup, projectId, handleDisableClick, handleCustomFieldSelect, t]);

    if (!actions.length) {
        return null;
    }

    return (
        <div className={className + (visible ? ' visible' : '')} onClick={handleTriggerClick}>
            <span className={innerClassName}><IconMoreHoriz /></span>

            <Popout
                className="xsmall"
                onShow={handleShow}
                onHide={handleHide}
                provideController={popoutCtrl}
             >
                <PopoutListActions actions={actions} renderAction={renderAction} updatePopoutPosition={popoutCtrl.current?.updatePosition} />
            </Popout>
        </div>
    );
}

const makeMapStateToProps = () => {
    const getProject = makeGetProject();

    return ({ projects }, ownProps) => {
        const project = getProject(projects.items, ownProps.projectId);
        return {
            milestonesRollup: project?.milestones_rollup,
            projectOwner: project?.owner
        };
    };
}

export default connect(makeMapStateToProps)(RoadmapActions);
